import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme/darkTheme';

interface StyledLayoutProps {
  readonly $pt?: string | number;
  readonly $pb?: string | number;
  readonly $customStyles?: string;
  readonly $autoHeight?: boolean;
}

interface LogoWrapperProps {
  readonly $hideOnMobile?: boolean;
}

export const StyledLayout = styled.div<StyledLayoutProps>`
  width: 100%;
  flex: 1 0 auto;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme?.tabletMinWidth}px) {
    justify-content: center;
  }

  @media screen and (max-width: ${({ theme }) => theme?.mobileWidth}px) {
    justify-content: flex-start;
  }

  ${({ $autoHeight, theme }) =>
    $autoHeight &&
    css`
      @media screen and (max-width: ${theme?.desktopMinWidth}px), screen and (max-height: 950px) {
        min-height: auto;
      }
    `};

  & > * {
    width: 100%;
  }

  ${({ $customStyles }) => $customStyles};
`;

export const LogoWrapper = styled.div<LogoWrapperProps>`
  position: absolute;
  top: 56px;
  left: 10%;
  width: unset;
  display: flex;
  align-items: center;
  gap: 8px;

  & > span {
    font-weight: 750;
    font-size: 19px;
    line-height: 19px;
    color: rgba(50, 50, 50, 1);

    @media screen and (max-width: 900px) {
      font-size: 12px;
      line-height: 12px;
    }

    ${darkMode(css`
      color: ${darkPalette.textPrimary};
    `)}
  }
  ${({ $hideOnMobile }) =>
    !$hideOnMobile &&
    css`
      position: relative;
      top: 0;
      left: 0;
    `};

  @media screen and (max-width: 744px) {
    display: none;
  }

  @media screen and (max-height: 900px) {
    display: ${({ $hideOnMobile }) => ($hideOnMobile ? 'none' : 'flex')};
  }
`;
